import { List } from '@mui/material';

import { SidebarMenuItem } from './index';
import AccessGuard from '../AccessGuard';
import { useUserContext } from '../../hooks/Contexts/UserContext';
import SidebarMenuSubListItem from './SidebarMenuSubListItem';

interface SidebarMenuSubListProps {
    items: SidebarMenuItem[];
    onCollapse?: (item: SidebarMenuItem, index: number) => void;
}

const SidebarMenuSubList = (props: SidebarMenuSubListProps) => {
    const { items, onCollapse } = props;
    const { userContext } = useUserContext();

    return (
        <List disablePadding>
            {items.map((item: SidebarMenuItem, index: number) => {
                return (
                    <AccessGuard
                        key={index}
                        accessGroup={item?.accessGroup || ''}
                        accessAgency={item?.accessAgency || ''}
                        condition={item?.condition ? () => item.condition!(userContext) : undefined}
                    >
                        <SidebarMenuSubListItem
                            item={item}
                            handleCollapse={(newItem: SidebarMenuItem) => {
                                if (onCollapse) {
                                    onCollapse(newItem, index);
                                }
                            }}
                        />
                    </AccessGuard>
                );
            })}
        </List>
    );
};

export default SidebarMenuSubList;
